export const translations = {
  es: {
    nav: {
      service: "Servicio",
      contact: "Contacto",
      lang: "EN/ES"
    },
    hero: {
      title_part1: "La",
      title_span: " solución",
      title_part2: " es un clic.",
      subtitle: "Soluciones tecnológicas, tu empresa compite alto, y nuestros expertos confían en tus sueños.",
      contact_text: "Contacta con expertos, y agenda proyectos para optimizar el funcionamiento de los sistemas de tu empresa.",
      form_placeholder: "Recibe un correo por parte de nosotros",
      form_button: "Enviame un mail",
      action_contact: "Contacta con un asesor",
      action_know: "Conoce nuestros servicios",
      // Nuevos mensajes de feedback
      success_msg: "✅ Enviado correctamente. Te contactaremos pronto.",
      error_msg: "❌ Hubo un error. Por favor intenta de nuevo."
    }
  },
  en: {
    nav: {
      service: "Services",
      contact: "Contact",
      lang: "ES/EN"
    },
    hero: {
      title_part1: "The",
      title_span: " solution",
      title_part2: " is one click away.",
      subtitle: "Tech solutions, your company competes high, and our experts trust in your dreams.",
      contact_text: "Contact experts, and schedule projects to optimize the functioning of your company's systems.",
      form_placeholder: "Receive an email from us",
      form_button: "Send me an email",
      action_contact: "Contact an advisor",
      action_know: "Know our services",
      // Nuevos mensajes de feedback
      success_msg: "✅ Sent successfully. We will contact you soon.",
      error_msg: "❌ There was an error. Please try again."
    }
  }
};